export type TournamentPhase =
  | 'UNKNOWN'
  | 'WAITING'
  | 'TRADING'
  | 'FINALIZING'
  | 'FINISHED'
  | 'CANCELLED';

const DEFAULT_TOLERANCE_MS = 30_000;

export const deriveTournamentPhase = (
  status: string | null | undefined,
  endAt: string | Date | number | null | undefined,
  now: number = Date.now(),
  toleranceMs: number = DEFAULT_TOLERANCE_MS,
): TournamentPhase => {
  if (status === 'CANCELLED' || status === 'cancelled') return 'CANCELLED';
  if (status === 'FINISHED' || status === 'finished') return 'FINISHED';
  if (status === 'FINISHING' || status === 'finishing') return 'FINALIZING';
  if (status === 'BEFORE_START' || status === 'new' || status === 'before_start') return 'WAITING';

  if (status === 'IN_PROGRESS' || status === 'in_progress') {
    const endMs = parseEndAt(endAt);
    if (endMs != null && endMs + toleranceMs <= now) {
      return 'FINALIZING';
    }
    return 'TRADING';
  }

  return 'UNKNOWN';
};

const parseEndAt = (endAt: string | Date | number | null | undefined): number | null => {
  if (endAt == null) return null;
  if (typeof endAt === 'number') return Number.isFinite(endAt) ? endAt : null;
  if (endAt instanceof Date) {
    const ms = endAt.getTime();
    return Number.isFinite(ms) ? ms : null;
  }
  const ms = Date.parse(String(endAt));
  return Number.isFinite(ms) ? ms : null;
};

export const isTradingActive = (phase: TournamentPhase): boolean => phase === 'TRADING';
